<template>
    <b-modal class="modal-content" ref="mdlAgendaModalNuovaDataComponent" title="Configurazione Parametri Intevallo"
        no-close-on-backdrop no-close-on-select @ok="oOkMdlAgendaModalNuovaDataComponent">
        <div class="modal-body">
            <b-row style="margin-top: 5px; padding: 10px; background: #f2f2f2">

                <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                    <label for="" class="col-form-label">Giorno Specifico</label>
                    <date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="setGiorno" type="date"
                        :placeholder="this.$i18n.t('agenda.lblDateFrom')"></date-picker>
                    <small>Agenda per Data Specifica</small>
                </b-col>
                <div class="col-6">
                    <label for="" class="col-form-label">Giorno Settimana</label>
                    <br />
                    <b-form-select id="inline-form-custom-select-pref" :options="giorniOptions" v-model="setGiorno"
                        :value="null" value-field="value" text-field="giorno"></b-form-select>
                    <small>Agenda per giorno settimana</small>
                </div>
                <div class="col-6">
                    <div class="custom-control custom-checkbox">
                        <br />
                        <b-form-checkbox v-model="setDefault">Default</b-form-checkbox>
                        <small>Calendario generato di Default per tutti i giorni</small>
                    </div>
                </div>
                <div class="col-6">
                    <div class="custom-control custom-checkbox">
                        <br />
                        <input type="checkbox" class="custom-control-input" v-model="setEsclusivo" id="customCheck2"
                            switch />
                        <label class="custom-control-label" for="customCheck2">{{
                            this.$i18n.t("patient.agenda.lblExclusive") }}</label>
                    </div>
                    <small>Calendario esclusivo</small>
                </div>
            </b-row>
        </div>
    </b-modal>
</template>

<script>
import DatePicker from "vue2-datepicker";
export default {
    components: { DatePicker },
    data() {
        return {
            jsonData: { idAgenda: null, giorno: "default", esclusivo: false, intervalli: [] },
            giorniOptions: [
                { value: null, giorno: "---- Seleziona un giorno ----" },
                { value: "1", giorno: "Domenica" },
                { value: "2", giorno: "Lunedì" },
                { value: "3", giorno: "Martedì" },
                { value: "4", giorno: "Mercoledì" },
                { value: "5", giorno: "Giovedì" },
                { value: "6", giorno: "Venerdì" },
                { value: "7", giorno: "Sabato" },
            ],
            parametroSelezionato: null,
            isModifica: false,
        };
    },
    computed: {
        setDefault: {
            get: function () {
                return this.jsonData.giorno == "default" ? true : false;
            },
            set: function (a) {
                console.log(a);

                this.jsonData.giorno = "default";
            },
        },
        setGiorno: {
            get: function () {
                return this.jsonData.giorno;
            },
            set: function (value) {
                this.jsonData.giorno = value;
            },
        },
        setEsclusivo: {
            get: function () {
                return this.jsonData.esclusivo;
            },
            set: function (value) {
                this.jsonData.esclusivo = value;
            },
        },
    },
    methods: {
        show() {
            let me = this;
            me.$refs.mdlAgendaModalNuovaDataComponent.show();
        },

        onModificaParametro(parameter) {
            this.parametroSelezionato = parameter;
            this.jsonData = parameter.parametro;
            this.isModifica = true;
            this.show();
        },
        oOkMdlAgendaModalNuovaDataComponent() {
            let me = this;
            this.isModifica ? this.$emit("modificaParametro", me.jsonData, this.parametroSelezionato) : this.$emit("addParametro", me.jsonData);
        },
        onHide() {
            this.parametroSelezionato = null;
            this.isModifica = false;
            this.jsonData = { idAgenda: null, giorno: "default", esclusivo: false, intervalli: [] };
        },
        nuovoParametro() {
            this.onHide();
            this.show();

        }
    },
};
</script>

<style></style>
